import TradeAgreementsRegister from './TradeAgreementsRegister';
export default TradeAgreementsRegister;
